import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import { styled } from 'stitches.config';

import Header from '@/components/Header';
import Typography from '@/components/sushi/Typography';
import { SitemapCategory } from '@/components/sitemap/SitemapCategory';
import { SitemapBlogCategory } from '@/components/sitemap/SitemapBlogCategory';
import { blogCategories, sitemapLinks } from '@/constants/sitemap';

const HomeWrapper = styled('div', {
  overflow: 'hidden auto',
  height: '100vh',
  background: 'white',
});

const SitemapContainer = styled('div', {
  padding: 36,
  margin: 'auto',
  marginTop: 100,
  maxWidth: 1264,
});

const Sitemap = () => {
  const router = useRouter();
  const locale = router.locale;
  const { formatMessage } = useIntl();

  return (
    <HomeWrapper id="home-wrapper">
      <Header />

      <SitemapContainer>
        <Typography variant="headingM" color="primaryAlt" className="mb-6">
          {formatMessage({ id: 'sitemap.title' })}
        </Typography>

        {locale === 'fr' ? (
          <div className="mt-4">
            {blogCategories.map((category) => (
              <>
                <SitemapBlogCategory category={category} />
                <hr className="my-5 opacity-20" />
              </>
            ))}
          </div>
        ) : null}

        <div className="flex flex-col lg:flex-row" style={{ justifyContent: 'space-between' }}>
          <SitemapCategory locale={locale} title="tools" links={sitemapLinks['tools']} />

          {locale === 'fr' ? (
            <div className="flex gap-10 mt-10 lg:mt-0" style={{ flexDirection: 'column' }}>
              <SitemapCategory
                locale={locale}
                title="cryptoComparison"
                links={sitemapLinks['cryptoComparison']}
              />

              <SitemapCategory
                locale={locale}
                title="budgetComparison"
                links={sitemapLinks['budgetComparison']}
              />
            </div>
          ) : null}
        </div>

        <div className="flex flex-col gap-6 lg:gap-0 lg:flex-row mt-10" style={{ justifyContent: 'space-between' }}>
          {['solutions', 'features', 'crypto', 'resources', 'about'].map((key) => {
            return sitemapLinks[key].some((link: { supportedLocales: string[] }) =>
              link.supportedLocales.includes(locale)
            ) ? (
              <SitemapCategory
                key={key}
                title={key}
                locale={locale}
                links={sitemapLinks[key]}
                variant="col"
              />
            ) : null;
          })}
        </div>

        <hr className="my-5 opacity-20" />

        <div className="flex flex-col gap-1 lg:flex-row" style={{ justifyContent: 'space-between' }}>
          {sitemapLinks['footer']
            .filter((link) => link.supportedLocales.includes(locale))
            .map(({ name, href }) => (
              <Typography
                key={name}
                as="a"
                href={`https://finary.com/${locale}${href}`}
                variant="bodyL"
                color="primaryAlt">
                {formatMessage({ id: `sitemap.footer.${name}` })}
              </Typography>
            ))}
        </div>
      </SitemapContainer>
    </HomeWrapper>
  );
};

export default Sitemap;
